"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));
var styled_system_1 = require("styled-system");
var systemProps = (0, styled_system_1.compose)(styled_system_1.space, styled_system_1.color, styled_system_1.typography, styled_system_1.layout, styled_system_1.flexbox, styled_system_1.grid, styled_system_1.border, styled_system_1.position, styled_system_1.shadow);
/**
 * This is the Compass Base component. Passing in a design token name will be accepted as a value
 */
exports.View = (0, styled_1.default)('div', { shouldForwardProp: should_forward_prop_1.default })([
    {
        boxSizing: 'border-box',
        minWidth: 0,
        margin: 0,
    },
    systemProps,
    function (_a) {
        var border = _a.border;
        if (typeof border === 'string' && (border === 'card' || border === 'nav')) {
            return {
                border: border === 'card' ? 'var(--border-card)' : 'var(--border-nav)',
            };
        }
        return {};
    },
]);
//# sourceMappingURL=index.js.map